import { Hidden, useStepperContext, Wrapper } from '@ahmdigital/ui';
import { last } from 'lodash/fp';
import React from 'react';

import { analyticsLabels } from '../../constants';
import { ForwardButtonsWrapper, StyledButton, StyledWrapper } from './styles';
import ForwardButtons from '../forward-buttons';

type Props = {
  onNextClick?: Function;
};

const StepFooterNavigation = ({ onNextClick }: Props) => {
  const { activeStep, goToPreviousStep, steps } = useStepperContext();

  const isLastStep = activeStep === last(steps);
  const isFirstStep = activeStep === steps?.[0];

  return (
    <Wrapper size="large">
      <StyledWrapper isLastStep={isLastStep} variant={['paddingTopSpacer8', 'paddingBottomSpacer10']}>
        <Hidden df lg>
          <ForwardButtons onNextClick={onNextClick} />
        </Hidden>
        {goToPreviousStep && !isFirstStep && (
          <StyledButton
            analytics={{ label: `Back - ${analyticsLabels[activeStep]}` }}
            variant={['white', 'border']}
            onClick={goToPreviousStep}
          >
            Back
          </StyledButton>
        )}
        <Hidden xs sm md>
          <ForwardButtonsWrapper>
            <ForwardButtons onNextClick={onNextClick} />
          </ForwardButtonsWrapper>
        </Hidden>
      </StyledWrapper>
    </Wrapper>
  );
};

export default StepFooterNavigation;
